var map = {
	"./2024_11_15_131_Kleki.png": 7269,
	"./2024_11_15_13e_Kleki.png": 9865,
	"./Zeno_Achilles_Paradox.png": 9116,
	"./anotador-de-truco-banner.png": 5597,
	"./anotador-truco.png": 8550,
	"./anxiety.jpg": 4222,
	"./banner.png": 5990,
	"./crossword.jpg": 3178,
	"./deck-of-cards.jpg": 5319,
	"./direction-6839518_640.jpg": 2301,
	"./flag.jpg": 8058,
	"./fondo-download-lf.png": 4,
	"./fondo-section-lf-negro.png": 5195,
	"./fondo-section-lf.png": 1699,
	"./game.jpg": 3658,
	"./gaucho.jpg": 2167,
	"./health.jpg": 6834,
	"./icono-web.png": 3649,
	"./icono.png": 4468,
	"./letras-fugitivas-desafio-diario.png": 3893,
	"./letras-fugitivas-pantallas-juego.png": 4094,
	"./letras-fugitivas-pantallas.png": 4019,
	"./map.jpg": 4892,
	"./mate.jpg": 4435,
	"./mockup-anot-truc.png": 457,
	"./papel-con-rayas.png": 2234,
	"./playing-cards.jpg": 3194,
	"./puzzle-1-solucion.png": 9629,
	"./puzzle-1.png": 9186,
	"./puzzle-2-solucion.png": 8808,
	"./puzzle-2.png": 3721,
	"./puzzle.jpg": 2200,
	"./scrabble.jpg": 2616,
	"./understanding.jpg": 7168
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1215;